import * as S from './index.styles';

function Footer() {
	return (
		<S.Footer>Copyright ⓒ 2024 (주)넷플레이스. All rights reserved.</S.Footer>
	);
}

export default Footer;
